import produce from 'immer';
import {
    SET_CURRENT_PRODUCT,
    SET_IS_SIZES_VISIBLE,
    SET_SIZE_GUIDE,
    SET_SIZE_PROMPT_TYPE
} from '../actions/constants';

const initialState = {
    currentProduct: {},
    isSizesVisible: false,
    sizeGuide: null,
    sizePromptType: 'modal'
};

const addToCart = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_CURRENT_PRODUCT: {
            state.currentProduct = payload;
            break;
        }

        case SET_IS_SIZES_VISIBLE: {
            state.isSizesVisible = payload;
            break;
        }

        case SET_SIZE_GUIDE: {
            state.sizeGuide = payload;
            break;
        }

        case SET_SIZE_PROMPT_TYPE: {
            state.sizePromptType = payload;
            break;
        }
        // skip default
    }
}, initialState);

export default addToCart;
